import React from 'react';
import { connect } from 'react-redux';
import { initialize } from '../actions/subscriptionActions';
import { withTranslation } from "react-i18next";

import Error from './Error';
import Loading from './Loading';
import OptOutSwitch from './OptOutSwitch';
import SaveButton from './SaveButton';
import Notification from './Notification';
import { Row,Col } from 'antd';

class Recipient extends React.Component {
  constructor(props) {
    super(props);
    var { i18n } = props;
    if(props.match && props.match.params && props.match.params.language) {
      i18n.changeLanguage(props.match.params.language);
    }
  }
  
  componentDidMount() {
    var recipientUuid = this.props.match.params.recipientUuid;
    this.props.initialize(recipientUuid);
  }
  
  render() {
    var { t } = this.props;
    var { recipient, error, messageType} = this.props;
    if (error) {
      return (
        <Error message={error.message}></Error>
      );
    } else if (!recipient) {
      return (
        <Loading></Loading>
      );
    } else {
      var message;
      var subMessage;
      var messageClass;
      var imgProps;
      var typeTitle;
      var typeDescription;
      if(messageType === 'subscribe') {
        message = t('optedInTitle');
        subMessage = '\n\n';
        messageClass = "emailMessage";
        imgProps = {
          src:'/images/img-subscribe.png',
          srcSet: '/images/img-subscribe@2x.png 2x,/images/img-subscribe@3x.png 3x'
        };
      } else {
        message = t('optedOutTitle');
        subMessage = t('optedOutSubtitle');
        messageClass = "emailMessage optedout";
        imgProps = {
          src:'/images/img-unsubscribe.png',
          srcSet: '/images/img-unsubscribe@2x.png 2x,/images/img-unsubscribe@3x.png 3x'
        };
      }

      if(this.props.match.params.type === 'b2b') {
        typeTitle = t('typeTitleB2b');
        typeDescription = t('typeDescriptionB2b');
      } else {
        typeTitle = t('typeTitle');
        typeDescription = t('typeDescription');
      }

      return (
          <div>
            <Notification />
            <Row type="flex" justify="center">
              <Col xs={24} sm={24} md={24} lg={12} xl={10}>
                <div className="header">{t('communicationPreferences')}</div>
                <div className="emailTitle">{t('managePreferences')}</div>
                <div className="email">{recipient.email}</div>
                <div className="subscriptionImage"><img alt="Subscription" {...imgProps} /></div>

                <div className={messageClass}>{message}</div>
                <div className="emailMessageSubtitle">{subMessage}</div>
                <div className="groupPreferences">
                  <div className="groupDetails">
                    <Row type="flex" align="middle">
                      <Col xs={20} sm={20} md={20} lg={18} xl={20}>
                          <div className="groupName">{typeTitle}</div>
                          <div className="groupDescription">{typeDescription}</div>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={6} xl={4}>
                        <div className="groupToggle">
                          <OptOutSwitch />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <SaveButton />
              </Col>
            </Row>
          </div>
            
      );
    }
  }
}

const mapStateToProps = state => ({
  recipient: state.recipient,
  error: state.error,
  messageType: state.status.messageType
});

export default connect(mapStateToProps,{ initialize })(withTranslation()(Recipient));